import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import {
  App, Form
} from "antd";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import useCurrentUser from "../../hooks/useCurrentUser";
import { ADD_APPOINTMENT } from "./book.qql";
import { appRoutes } from "../../constants/routes";
import { currentDoctor } from "../../store/slices/user";
import { useAppSelector } from "../../store";

const useBook = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { data: userData } = useCurrentUser();
  const doctor = useAppSelector(currentDoctor);

  const [addAppointment, { data: appointmentData, loading }] = useMutation(ADD_APPOINTMENT, {
    fetchPolicy: "no-cache",

    onCompleted(data: { addAppointment: string }) {
      if (data && data.addAppointment.split(",")[0] === "id") {
        navigate(`${appRoutes.success}?appointment_id=${data.addAppointment.split(",")[1]}`);
      } else {
        window.location.href = data.addAppointment;
      }
    },
    onError() {
      message.error(t("apollo.error.addAppointment"));
    }
  });

  useEffect(() => {
    if (!state?.activeDate) {
      navigate(appRoutes.appointments);
      message.error(t("global.error.dataError"));
    }
  }, [state]);

  const handleSubmit = (values: any) => {
    if (!doctor) {
      message.error(t("user.error.getDoctor"));
      return;
    }

    const {
      prefix, phone, tesseraSanitariaAuth, ...rest
    } = values;

    addAppointment({
      variables: {
        professionistId: +doctor.id,
        patientId: +userData.id,
        startAt: state.activeDate,
        phone: `${phone.prefix}${phone.number}`,
        tesseraSanitariaAuth: tesseraSanitariaAuth ?? false,
        ...rest
      }
    });
  };

  return {
    handleSubmit,
    appointmentData,
    loading,
    navigate,
    form
  };
};

export default useBook;
